import { render } from "./MainButton.vue?vue&type=template&id=24138a16&ts=true&lang=pug"
import script from "./MainButton.vue?vue&type=script&lang=ts"
export * from "./MainButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__